import React, { useState } from 'react';

import style from '../../../css/admin/Workshopupload.module.css';
import ViewStudymaterial from './Studymaterial_table_data';

const WorkshopUpload = () => {


  return (
    <>
        <div className={style.uploadContainer}>
        <button className={style.uploadButton} onClick={() => window.open('/study-upload-page', '_blank')}>
          <i className="fa-solid fa-cloud-arrow-up"></i> Study Material
        </button>
      </div>
      <ViewStudymaterial/>
    </>
  );
};

export default WorkshopUpload;
